import ApiService from './ApiService'

export const apiLogIn = data => ApiService.post('/api/v1/auth/login/', data)
export const apiLogOut = data => ApiService.post('/api/v1/auth/logout/', data)
export const apiChangePassword = data => ApiService.put('/api/v1/auth/change-password/', data)
export const apiForgotPassword = data => ApiService.post('/api/v1/auth/forgot-password/', data)
export const apiResetPassword = data => ApiService.post('/api/v1/auth/reset-password/', data)
export const apiVerify = data => ApiService.post('/api/v1/auth/mfa/verify/', data)
export const apiMFASetup = data => ApiService.post('/api/v1/auth/mfa/setup/', data)
export const getApiUser = () => ApiService.get(`/userauth/userprofiles/`)
export const getApiProfile = id => ApiService.get(`/userauth/userprofiles/${id}/`)
export const updateApiProfile = (id, data) => ApiService.put(`/userauth/userprofiles/${id}/`, data)
